import React from "react";
import dva from "dva";
import Router from "./Router";
import auth from "./models/auth";
import router from "./models/router";
import drivers from "./models/drivers1";
import shop from "./models/shop1";
import category from "./models/category1";
import products from "./models/product1";
import addOns from "./models/addOns";
import orders from "./models/orders1";
import promotions from "./models/promotions";
import reviews from "./models/reviews1";
import user from "./models/user";
import refundRequests from "./models/refundRequests1";
import customers from "./models/customers";
import { globalErrorHandler } from "./utils/errorHandler";
import "antd/dist/antd.css";
import "./styles/lib.scss";
import "./styles/global.scss";
import "react-phone-input-2/lib/style.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ConfigProvider } from "antd";
import analytic from "./models/analytic";
import transactions from "./models/transactions";
import profile from "./models/profile";
import tables from "./models/tables";
import inventory from "./models/inventory";
import shift from "./models/shift";
export const app = dva({
  onError: globalErrorHandler,
});

app.model(auth);
app.model(drivers);
app.model(category);
app.model(products);
app.model(addOns);
app.model(inventory);
app.model(analytic);
app.model(router);
app.model(tables);
// app.model(user);
app.model(shop);
app.model(orders);
app.model(reviews);
app.model(refundRequests);
app.model(customers);
app.model(promotions);
app.model(transactions);
app.model(profile);
app.model(shift);

app.router(() => (
  <ConfigProvider componentSize="middle">
    <Router />
  </ConfigProvider>
));
export default app.start();
